/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Jpc_Departure_ValInputs */

const es_cap_jpc_departure_val = /** @type {(inputs: Cap_Jpc_Departure_ValInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vigo → Islas Cíes`)
};

const gl_cap_jpc_departure_val = /** @type {(inputs: Cap_Jpc_Departure_ValInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vigo → Illas Cíes`)
};

const en_cap_jpc_departure_val = /** @type {(inputs: Cap_Jpc_Departure_ValInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vigo → Cíes Islands`)
};

/**
* | output |
* | --- |
* | "Vigo → Cíes Islands" |
*
* @param {Cap_Jpc_Departure_ValInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_jpc_departure_val = /** @type {((inputs?: Cap_Jpc_Departure_ValInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Jpc_Departure_ValInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_jpc_departure_val(inputs)
	if (locale === "en") return en_cap_jpc_departure_val(inputs)
	return es_cap_jpc_departure_val(inputs)
});